import React, { useContext, useEffect, useState } from "react";
import { BranchContext } from "../../context/branch/BranchContext";
import { useNavigate } from "react-router-dom";

export const BranchesPage = () => {

    const [buscar, setBuscar] = useState('');
    const { banks, branches, loadBranches, deleteBranch } = useContext(BranchContext);

    const navigate = useNavigate();

    useEffect(() => {
        loadBranches();
    }, []);

    const getBankName = (fiId) => {
        return banks.find(bank => bank.fiId == fiId)?.name || '';
    };


    const filteredData = branches.filter(branch => {
        const search = buscar.toLowerCase();
        const bankName = getBankName(branch.fiId)?.toLowerCase() || '';

        return (
            branch.name?.toLowerCase().includes(search) ||
            branch.code?.toLowerCase().includes(search) ||
            bankName.includes(search)
        );
    });

    const handleEdit = (branch) => {
        navigate("/branch", { state: { branch } });
    };

    const handleDelete = async (id) => {

        const resp = await deleteBranch(id);

        if (resp !== "success") {
            alert(resp);
        }

    };

    const handleNew = () => {
        navigate("/branch");
    };


    return (

        <div className="container mt-5">

            <div className="row justify-content-end mt-5">

                <div className="col-md-3">
                    <input
                        className="form-control"
                        placeholder="Buscar"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                    />
                </div>

                <div className="col-md-1">
                    <button
                        className="btn btn-success"
                        onClick={handleNew}
                    >
                        Nuevo
                    </button>
                </div>

            </div>

            <br />

            <table className="table table-hover table-striped">

                <thead className="thead-dark">
                    <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Banco</th>
                        <th style={{ textAlign: "center" }}>Acciones</th>
                    </tr>
                </thead>

                <tbody>

                    {
                        filteredData.length > 0
                            ?
                            filteredData.map(branch => (

                                <tr key={branch.id}>

                                    <td>{branch.code}</td>
                                    <td>{branch.name}</td>
                                    <td>{getBankName(branch.fiId)}</td>

                                    <td style={{ textAlign: "center" }}>


                                        <button type="button" className="btn btn-primary" onClick={() => handleEdit(branch)}> <i className="bi bi-pencil"></i></button>

                                        <button type="button" className="btn btn-danger" style={{ marginLeft: '10px' }} onClick={() => handleDelete(branch.id)}><i className="bi bi-trash"></i></button>

                                    </td>

                                </tr>

                            ))
                            :
                            <tr>
                                <td colSpan={4} className="text-center">
                                    No existen sucursales
                                </td>
                            </tr>
                    }

                </tbody>

            </table>

        </div>

    );
};